var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6432 14.7908L18.0071 17.3981C18.1004 18.0829 17.27 18.5615 16.6076 18.2067L13.3792 16.507C13.1553 16.3915 13.0993 16.144 13.2206 15.946C13.6871 15.1869 13.939 14.3288 13.939 13.4707C13.939 10.4508 11.0093 7.99205 7.40771 7.99205C6.6706 7.99205 5.95215 8.09106 5.28036 8.28909C4.93513 8.3881 4.59923 8.10757 4.68321 7.79403C5.53228 4.79069 8.79795 2.55469 12.6981 2.55469C17.2514 2.55469 20.9369 5.59928 20.9369 9.35346C20.9369 11.5812 19.64 13.5532 17.6432 14.7908Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5392 13.4675C12.5392 14.4494 12.1286 15.357 11.4382 16.0748C10.5145 17.065 9.04957 17.7003 7.4074 17.7003L4.97214 18.9792C4.5616 19.2019 4.0391 18.8967 4.09508 18.4759L4.32834 16.8504C3.07806 16.0831 2.27563 14.8537 2.27563 13.4675C2.27563 12.0154 3.1527 10.7365 4.49629 9.9774C5.3267 9.49884 6.32507 9.22656 7.4074 9.22656C10.2439 9.22656 12.5392 11.1243 12.5392 13.4675Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterContact);
export default __webpack_public_path__ + "static/media/FooterContact.b6f80b76a4713bad30798ccb1e7eda01.svg";
export { ForwardRef as ReactComponent };